// Mock data for Diamond Trucking School

export const contactInfo = {
  phone: '(425) 890-2558',
  email: 'diamondtruckingschool@gmail.com',
  address: '8217 44th Ave W. Bldg. F, Suite B, Mukilteo, WA 98275',
  businessHours: 'Monday - Friday: 8:00 am to 3:00 pm',
  classHours: 'Monday - Thursday: 7:00 am - 5:00 pm',
  weekendHours: 'Saturday - Sunday: 7:00 am - 5:00 pm'
};

export const programs = [
  {
    id: 1,
    title: 'Class A CDL',
    subtitle: 'Commercial Driving',
    price: '',
    duration: '4-6 Weeks',
    description: 'Get your Class A Commercial Driver\'s License and start hauling freight across multiple states. Travel throughout North America including Canada and Mexico.',
    features: [
      'Commercial freight hauling certification',
      'Defensive driving techniques',
      'Mountain and highway driving',
      'All-weather training',
      'Job placement assistance'
    ]
  },
  {
    id: 2,
    title: 'Class B CDL',
    subtitle: 'Commercial Driving',
    price: '',
    duration: '3-4 Weeks',
    description: 'Obtain your Class B CDL for local and regional hauling. Stay closer to home while enjoying the open roads and picturesque countryside.',
    features: [
      'Commercial freight certification',
      'Local route familiarization',
      'City and rural driving',
      'Safety-first approach',
      'Flexible scheduling options'
    ]
  },
  {
    id: 3,
    title: 'Class B to Class A-Upgrade',
    subtitle: 'Commercial Driving Upgrade',
    price: '',
    duration: '3-4 Weeks',
    description: 'Upgrading from Class B to A adds tractor‑trailer privileges. It requires training (coupling, air brakes), passing Class A written and skills tests, and a medical certificate—unlocking higher‑paying jobs.',
    features: [
      'Commercial freight hauling certification',
      'Mountain and highway driving',
      'City and rural driving',
      'All-weather training',
      'High-demand career'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Roy Swihart',
    role: 'Interwest Construction',
    content: 'We have had an outstanding experience with Diamond Trucking School. Melissa and her team are incredibly knowledgeable, professional, and easy to work with. What really sets them apart is their mobile training capability, which has been a game changer for us as a company with divisions spread across Washington State. Their pricing is affordable, their equipment is top-notch, and the convenience they provide is hard to beat. Most importantly, they have delivered results — our team has had a 100% success rate going through their program. Excellent service, excellent instruction, and an excellent partner for workforce development. I would highly recommend Diamond Trucking School to any company or individual looking for high-quality CDL training.',
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What are the requirements to enroll?',
    answer: 'You must be at least 18 years old (21 for interstate), have a valid driver\'s license, and pass a DOT physical exam. We\'ll guide you through the entire process.'
  },
  {
    id: 2,
    question: 'How long does the training take?',
    answer: 'Class A training typically takes 4-6 weeks, Class B takes 3-4 weeks. We offer flexible schedules to accommodate individual needs.'
  },
  {
    id: 3,
    question: 'Do you offer job placement assistance?',
    answer: 'Yes! We work with numerous trucking companies and transportation services to help our graduates find employment quickly after certification.'
  },
  {
    id: 4,
    question: 'What is included in the training cost?',
    answer: 'The training cost covers classroom instruction, behind-the-wheel training, use of our trucks, all materials, and DOT physical and drug test.'
  },
  {
    id: 5,
    question: 'Do you offer financing options?',
    answer: 'Yes, we offer flexible payment plans and can help you explore financing options. Contact us to discuss what works best for your situation.'
  },
  {
    id: 6,
    question: 'What makes Diamond Trucking School different?',
    answer: 'Our focus on safety-first training, experienced instructors, personalized attention, and comprehensive all-weather driving preparation sets us apart. We prepare you for real-world driving conditions.'
  }
];

export const whyTruckingReasons = [
  {
    title: 'High Demand Career',
    description: 'Truck drivers are essential and always in demand. Enjoy job stability and security in an industry that needs you.'
  },
  {
    title: 'Great Salary',
    description: 'Competitive wages with opportunities for growth. Many drivers earn excellent income with benefits and bonuses.'
  },
  {
    title: 'Travel & Adventure',
    description: 'See different cities and states throughout North America. Many drivers love the lifestyle and freedom of the open road.'
  },
  {
    title: 'Quick Training',
    description: 'Get certified in just weeks, not years. Start your new career faster than most traditional education paths.'
  }
];

// Mock form submission
export const submitLeadForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Thank you! We\'ll contact you soon.' });
    }, 1000);
  });
};